import { createContext, useContext, useState, useCallback } from "react";
import { api } from "../lib/api";
import { registerPlayback } from "../lib/audioCoordinator";

const PlayerContext = createContext(null);

export function PlayerProvider({ children }) {
  const [current, setCurrent] = useState(null); // audio object
  const [queue, setQueue] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);

  const play = useCallback((audio, list = []) => {
    registerPlayback(() => setIsPlaying(false));
    setCurrent(audio);
    if (list.length) setQueue(list);
    setIsPlaying(true);
    api.post(`/audios/${audio.id}/play`).catch(() => {});
  }, []);

  const toggle = useCallback(() => {
    setIsPlaying((p) => {
      const next = !p;
      if (next) registerPlayback(() => setIsPlaying(false));
      return next;
    });
  }, []);

  const next = useCallback(() => {
    if (!current || queue.length === 0) return;
    const i = queue.findIndex((a) => a.id === current.id);
    const n = queue[(i + 1) % queue.length];
    registerPlayback(() => setIsPlaying(false));
    setCurrent(n);
    setIsPlaying(true);
  }, [current, queue]);

  const prev = useCallback(() => {
    if (!current || queue.length === 0) return;
    const i = queue.findIndex((a) => a.id === current.id);
    const p = queue[(i - 1 + queue.length) % queue.length];
    registerPlayback(() => setIsPlaying(false));
    setCurrent(p);
    setIsPlaying(true);
  }, [current, queue]);

  const close = useCallback(() => {
    setCurrent(null);
    setQueue([]);
    setIsPlaying(false);
  }, []);

  return (
    <PlayerContext.Provider value={{ current, isPlaying, play, toggle, next, prev, close }}>
      {children}
    </PlayerContext.Provider>
  );
}

export const usePlayer = () => useContext(PlayerContext);
